// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3XatD","footerInner":"style_footerInner__2vF5h","logo":"style_logo__PW_vL"};